import React from 'react';
import Card from 'react-bootstrap/Card';


function CardServicio3() {
    return (
        <Card style={{ width: '20rem', height: '32rem' }}>
            <Card.Body className='p-4 d-flex flex-column justify-content-between'>
                <div className="card-icon d-flex flex-column align-items-center mb-2">

                    <i class='bx bxs-dashboard'></i>
                    <h3 className='text-center mt-3'>Sistemas</h3>
                </div>
                <Card.Text>
                    <i class='bx bx-check'></i> Sistema empresarial a medida <br />
                    <i class='bx bx-check'></i> Panel de administración <br />
                    <i class='bx bx-check'></i> Roles y autenticación <br />
                    <i class='bx bx-check'></i> Reportes y dashboards <br />
                    <i class='bx bx-check'></i> API e integraciones <br />
                    <i class='bx bx-check'></i> Soporte y mantenimiento <br />
                </Card.Text>
                <div className='d-flex justify-content-center '>
                    <a href="https://wa.link/f1cp8b" className='btn btn-neon mt-2'>Más Info</a>
                </div>
            </Card.Body>
        </Card>
    );
}

export default CardServicio3;
